import React from 'react';
import { MainMatchesData } from './MainMatchesData';
import { FaRobot } from 'react-icons/fa';
import { IoStatsChart } from 'react-icons/io5';
import { BiFootball } from 'react-icons/bi';
import i18n from './i18n';

interface Props {
  selectedItemData: MainMatchesData;
  columnToShow?: 'left' | 'center' | 'right' | 'all';
}

export const AIMatchPrediction = ({
  selectedItemData,
  columnToShow = 'all',
}: Props) => {
  if (!selectedItemData) {
    return <div>No data available</div>;
  }

  // Determine which columns to show
  const showLeft = columnToShow === 'left' || columnToShow === 'all';
  const showCenter = columnToShow === 'center' || columnToShow === 'all';
  const showRight = columnToShow === 'right' || columnToShow === 'all';

  // Keep the original styles exactly as they were
  const tableStyle =
    columnToShow === 'all'
      ? { width: '500px', fontSize: '12px' }
      : { marginRight: '20px' };

  // Enhanced styles for better readability while keeping the layout
  const getHeaderStyle = (isHomeTeam: boolean) => {
    return isHomeTeam
      ? { background: 'linear-gradient(to right, #065f46, #064e3b)' }
      : { background: 'linear-gradient(to right, #1e40af, #1e3a8a)' };
  };

  // Function to get CSS class based on value
  const getValueClass = (scored: number, conceded: number): string => {
    const diff = scored - conceded;
    if (diff > 1) return 'text-green-500 font-bold';
    if (diff > 0) return 'text-green-400 font-bold';
    if (diff === 0) return 'text-gray-300 font-bold';
    if (diff > -1) return 'text-yellow-400 font-bold';
    return 'text-red-400 font-bold';
  };

  // Componente per intestazioni con icone
  const HeaderWithIcon = ({
    icon: Icon,
    text,
    style = {},
  }: {
    icon: React.ElementType;
    text: string;
    style?: React.CSSProperties;
  }) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
    >
      <Icon style={{ marginRight: '0.5rem' }} /> {text}
    </div>
  );

  // Componente per intestazioni di colonna con icone
  const ColumnHeaderWithIcon = ({
    icon: Icon,
    text,
  }: {
    icon: React.ElementType;
    text: string;
  }) => (
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Icon style={{ marginRight: '0.25rem' }} /> {text}
    </span>
  );

  const formatNotAvailableValue = (value: number | null | undefined) => {
    return value === 0 || value === null || value === undefined ? 'N/A' : value;
  };

  return (
    <div className="AIMatchPrediction">
      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th className="bg-gradient-to-r from-teal-800 to-indigo-900">
                <HeaderWithIcon icon={FaRobot} text="AI Prediction" />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p>
                  {i18n.language === 'it'
                    ? (selectedItemData.AI_Analysis?.ita ??
                      selectedItemData.AI_Analysis?.eng)
                    : selectedItemData.AI_Analysis?.eng}
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
